import { TranslatedText } from './translated-text';

export class ComboFilter {
  id: string;
  name: TranslatedText;
  price: number;
  priceChanges: any;
  imageUrl: string;
  originalImageUrl?: string;
  isAvailable: boolean;

  constructor(
    id: string,
    name: string | TranslatedText,
    price: number,
    imageUrl: string,
    priceChanges: any,
    originalImageUrl?: string,
  ) {
    this.id = id;
    this.name = typeof name === 'string' ? new TranslatedText(name) : name;
    this.price = price;
    this.priceChanges = priceChanges;
    this.imageUrl = imageUrl;
    this.originalImageUrl = originalImageUrl;
    this.isAvailable = true;
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
